import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { AuditTeamBean } from 'app/model/audit-team-bean';
import { TeamDetailBean } from 'app/model/team-detail-bean';

@Component({
  selector: 'app-team-detail',
  templateUrl: './team-detail.component.html',
  styleUrls: ['./team-detail.component.scss']
})
export class TeamDetailComponent implements OnInit {


  teamList: TeamDetailBean[] = [];

  auditProgramDetail: TeamDetailBean[];
  teamType: string;
  responseList = [];

  constructor(private route: Router,
    private dialogRef: MatDialogRef<TeamDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public recievedData: any) {
    this.auditProgramDetail = recievedData.auditProgramDetail;
    this.teamType = recievedData.teamType;
  }

  ngOnInit() {
    if (this.teamType == 'Auditee') {
      this.auditProgramDetail.forEach((element: TeamDetailBean) => {
        if (element.cdAccessPrivilegeType == '262')
          this.teamList.push(element);
      });
    }
    else if (this.teamType == 'Auditor') {
      this.auditProgramDetail.forEach((element: TeamDetailBean) => {
        if (element.cdAccessPrivilegeType == '261' && element.triggeredFlag != '1')
          this.teamList.push(element);
      });
    }
    else {
      this.auditProgramDetail.forEach((element: TeamDetailBean) => {
        if (element.triggeredFlag == '1')
          this.teamList.push(element);
      });
    }

  }





  closePopup() {
    this.dialogRef.close(true);
    return false;
  }

}

